import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Col } from '../../../base/Grid/grid';
import Icon from '../../../base/Icon/icon';
import Typography from '../../../base/Typography';
import Link from '../../../base/Link/link';

export const ColContentContainerStyled = styled(Col)`
  && {
    padding-right: 0;
  }
`;

export const ColIconContainerStyled = styled(Col)`
  && {
    padding: 0;
  }
`;

export const IconStyled = styled(Icon)`
  ${({ theme }) => {
    const largeUp = theme.useMediaQuery(theme.breakpoints.up('large'));
    const mediumUp = theme.useMediaQuery(theme.breakpoints.up('medium'));
    let marginTop = rem(2);

    if (largeUp) {
      marginTop = rem(3);
    } else if (mediumUp) {
      marginTop = rem(4);
    }

    return css`
      width: 100%;
      margin-top: ${marginTop};
      height: auto;
      max-height: ${rem(30)};
      color: ${theme.colors.cta.blue};
    `;
  }
}
`;

export const LinkStyled = styled(Link)`
  white-space: nowrap;
`;

export const ProductResourceCalloutContainer = styled.div`
  && {
    width: 100%;
    margin-bottom: ${rem(40)};
  }
`;

export const TypographyStyled = styled(Typography)`
  && {
    padding-bottom: ${rem(5)};
  }
`;

